import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { InputGroup } from './InputGroup';
import { CheckboxButton } from './CheckboxButton';
import { languageOptions } from '../../utils/languagesUtils';

interface FormLanguageSelectorProps {
  value: string[];
  onChange: (languages: string[]) => void;
  error?: string;
  required?: boolean;
  optionWrapperClassName?: string;
  name?: string;
}

const FormLanguageSelector: React.FC<FormLanguageSelectorProps> = ({
  value,
  onChange,
  error,
  required,
  optionWrapperClassName,
  name,
}) => {
  const { t } = useTranslation('common');

  return (
    <InputGroup
      label={t('form_fields.languagesSpoken')}
      name={name}
      required={required}
      error={!!error}
      errorMessage={error}
    >
      <div
        className={`flex space-x-4 mt-2 ${optionWrapperClassName}`}
        role="group"
        aria-invalid={!!error || undefined}
        aria-describedby={error && name ? `${name}-error` : undefined}
      >
        {languageOptions.map(lang => (
          <CheckboxButton
            key={lang.code}
            checked={value.includes(lang.code)}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.checked) {
                onChange([...value, lang.code]);
              } else {
                onChange(value.filter(l => l !== lang.code));
              }
            }}
            label={lang.label}
            value={lang.code}
          />
        ))}
      </div>
    </InputGroup>
  );
};

export default FormLanguageSelector;
